<template>
  <div>
    <div class="space-y-4 m-6" v-if="album">
      <div class="text-3xl font-bold">{{ album.title }}</div>

      <div>{{ dateRangeFormatted }}</div>

      <!-- <div v-if="album.comment">{{ album.comment }}</div> -->

      <vue-markdown
        v-if="album.comment"
        :source="album.comment"
        class="my-prose"
      />

      <!-- <Teleport to="#teleport">
        <Slider :min="50" :max="500" v-model="basis" />
      </Teleport> -->

      <ClientOnly>
        <Teleport to="#teleport">
          <MyButton @click="sortAscending = !sortAscending" variant="small">
            {{ sortLabel }}
          </MyButton>
        </Teleport>
      </ClientOnly>

      <div class="album-photos">
        <Photo
          v-for="(photo, index) in photosSorted"
          :key="photo.slug"
          :photo="photo"
          :dialog="dialog"
          @click="showFullScreen(index)"
          :basis="basis"
        />
      </div>
    </div>

    <PhotoOverlay
      v-model="dialog"
      v-model:index="currentIndex"
      :photos="photosSorted"
      :allow-download="album?.public === false"
    />
  </div>
</template>

<script lang="ts" setup>
import VueMarkdown from "vue-markdown-render";

const route = useRoute();
const slug = route.params.slug as string;
const api = useApi();
// const getRandomInt = (max: number) => Math.floor(Math.random() * max);

const basis = ref(250);

const dialog = ref(false);
const currentIndex = ref(0);

const sortAscending = ref(true);
const sortLabel = computed(() => (sortAscending.value ? "ASC" : "DESC"));

/**
 * This caching causes the back and forth redirect to challenge and back to fail.
 *
 * Better way to disable caching on useAsyncData
 */
const { data: album, error: errorAlbum } = await useAsyncData(
  // `getAlbum-${slug}-${getRandomInt(10000)}`,
  `getAlbum-${slug}`,
  () => api.albums.getAlbum(slug)
);

const { data: photos } = await useAsyncData(
  `getPhotos-${slug}`,
  () => api.albums.getPhotos(slug),
  {
    default: () => [],
  }
);

useHead({
  title: () => album.value?.title ?? "---",
});

const photosSorted = computed(() =>
  [...photos.value].sort((a, b) => {
    const A = a.timestamp ?? "";
    const B = b.timestamp ?? "";
    const factor = sortAscending.value ? 1 : -1;
    return factor * A.localeCompare(B);
  })
);

const redirectIfPasswordProtect = async () => {
  try {
    await api.albumPassword.getAlbumSlugAuth(slug);
    navigateTo({ name: "slug-challenge", params: { slug } });
  } catch {
    showError({ statusCode: 404, statusMessage: "Page not found." });
  }
};

watch(
  errorAlbum,
  (err) => {
    if (err) {
      redirectIfPasswordProtect();
    }
  },
  { immediate: true }
);

const dateRangeFormatted = computed(() =>
  album.value ? albumDateRangeFormat(album.value) : null
);

const showFullScreen = (index: number) => {
  currentIndex.value = index;
  dialog.value = true;
};
</script>

<style lang="postcss">
.album-photos {
  @apply flex flex-wrap justify-center gap-1;
}

.my-prose {
  @apply space-y-2;
  ul {
    @apply list-disc ml-6;
  }
}
</style>
